import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ShowingsPreview } from "@/components/ShowingsPreview";

interface ShowingsPreviewWrapperProps {
  northId: string;
  showingsSummary: string | null;
  showOnReport: boolean;
  viewMode: 'mobile' | 'desktop';
}

export function ShowingsPreviewWrapper({ 
  northId, 
  showingsSummary, 
  showOnReport, 
  viewMode 
}: ShowingsPreviewWrapperProps) {
  const { data: showings, isLoading } = useQuery({
    queryKey: ['showings-preview', northId],
    queryFn: async () => {
      const isDemo = northId === 'aaaaaaaa-0000-0000-0000-000000000001';
      if (isDemo) {
        const { data: demoShowings } = await supabase
          .from('demo_showing_events')
          .select('*')
          .eq('demo_report_id', northId)
          .order('scheduled_date', { ascending: false });
        return (demoShowings || []) as any[];
      }

      const { data, error } = await supabase
        .from('showing_events')
        .select('*')
        .eq('north_id', northId)
        .order('scheduled_date', { ascending: false })
        .limit(10);

      if (error) throw error;
      return (data || []) as any[];
    },
  });

  // Don't render if toggle is off, if loading, or if there's no data
  if (!showOnReport) return null;
  if (isLoading) return null;
  
  const hasData = showings && showings.length > 0;
  if (!hasData) return null;

  return (
    <div className={`rounded-xl bg-gradient-to-br from-primary/5 via-primary/10 to-background border border-border/50 shadow-sm ${viewMode === 'mobile' ? 'mb-8 p-6' : 'mb-12 p-8'}`}>
      <ShowingsPreview northId={northId} showingsSummary={showingsSummary} />
    </div>
  );
}
